const BASE_URL = process.env.REACT_APP_API_GW_END_POINT ?? '';

export const fetchUrl = {
  listTenant: `${BASE_URL}/list-tenant`,
  registerTenant: `${BASE_URL}/register-tenant`,
};
